export const DISEASE_INFORM = "DISEASE_INFORM";
export const DISEASE_INFORM_FETCHING = "DISEASE_INFORM_FETCHING";
export const DISEASE_INFORM_SUCCESS = "DISEASE_INFORM_SUCCESS";
export const DISEASE_INFORM_FAILED = "DISEASE_INFORM_FAILED";
export const DISEASE_REPORT = "DISEASE_REPORT";
export const DISEASE_REPORT_FETCHING = "DISEASE_REPORT_FETCHING";
export const DISEASE_REPORT_SUCCESS = "DISEASE_REPORT_SUCCESS";
export const DISEASE_REPORT_FAILED = "DISEASE_REPORT_FAILED";
